import React from "react";
import PropTypes from "prop-types";

import { FILE_UPLOAD_VARIANT } from "components/fileUpload/fileUpload.constants";
import DragDropBrowseFileUpload from "components/fileUpload/dragDropBrowseFileUpload";
import BrowseFileUpload from "components/fileUpload/browseFileUpload";

const { BROWSE, DRAG_DROP_BROWSE } = FILE_UPLOAD_VARIANT;
const FileUpload = (props) => {
  const {
    inputRef,
    name,
    label,
    value,
    required,
    touched,
    onChange,
    onBlur,
    helpTexts,
    fileUploadContainerClass,
    fileUploadClass,
    errors,
    showAllErrors,
    errorClass,
    invalidFieldClass,
    variant,
    onDragLeave,
    onDragOver,
    readOnly,
    progressValue,
    ...optionalProps
  } = props;

  const renderFileVariant = {
    [BROWSE]: <BrowseFileUpload {...props} />,
    [DRAG_DROP_BROWSE]: <DragDropBrowseFileUpload {...props} />,
  };

  return <>{renderFileVariant[variant]}</>;
};

FileUpload.defaultProps = {
  required: false,
  variant: BROWSE,
  inputRef: React.createRef(),
  onDragLeave: () => {},
  onDragOver: () => {},
};

FileUpload.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  required: PropTypes.bool,
  touched: PropTypes.bool,
  onChange: PropTypes.func,
  onDragLeave: PropTypes.func,
  onDragOver: PropTypes.func,
  onBlur: PropTypes.func,
  helpTexts: PropTypes.array,
  fileUploadClass: PropTypes.string,
  fileUploadContainerClass: PropTypes.string,
  errors: PropTypes.array,
  showAllErrors: PropTypes.bool,
  errorClass: PropTypes.string,
  invalidFieldClass: PropTypes.string,
  variant: PropTypes.string,
};

export default FileUpload;
